const adminUrlIsValid = (url: string | undefined): boolean => {
  // This method is a refactored port of sanityCheckSourceUrl from the monolith
  // The x,y,z params are required, but can be in any order
  // The URL being longer than 20 characters is a heuristic used to check if it contains required parts.
  // Custom URLs typically include a path pattern "http(s)://" "/{z}/{x}/{y}" followed by the actual server address.

  if (!url || url.length < 20 || !url.includes('{x}') || !url.includes('{y}') || !url.includes('{z}')) {
    return false;
  }
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
  } catch {
    return false;
  }
};

export default adminUrlIsValid;
